import { Card, Statistic } from 'antd';
import React from 'react';

import { DonorStatusFilter } from '../../constants';

interface IProps {
  title: string;
  icon: React.ReactNode;
  value: number;
  color: string;
  filter?: DonorStatusFilter;
  selectedFilter?: DonorStatusFilter | null;
  onStatusClick?: (filter: DonorStatusFilter) => void;
}

const MetricCard: React.FC<IProps> = ({
  title,
  icon,
  value,
  color,
  filter,
  selectedFilter,
  onStatusClick,
}) => {
  const isSelected = !!filter && selectedFilter === filter;

  return (
    <Card
      hoverable={!!filter}
      onClick={() => filter && onStatusClick?.(filter)}
      style={{
        cursor: filter ? 'pointer' : 'default',
        border: isSelected ? `2px solid ${color}` : undefined,
        boxShadow: isSelected ? `0 0 10px ${color}40` : undefined,
      }}
    >
      <Statistic
        title={title}
        value={value.toLocaleString()}
        prefix={icon}
        valueStyle={{ color }}
      />
    </Card>
  );
};

export default MetricCard;
